import currencyFormatter from 'currency-formatter';

export const calcTotal = (data: Array<number>) => {
  const result = data.reduce((total, item) => total + item, 0);
  return result;
};

export const calcPercent = (numerator: number, denominator: number): number => {
  if (!denominator) return 0;
  const result = (numerator * 100) / denominator;
  return Number(result.toFixed(1));
};

export const heightPercent = (fileSize: string) => {
  const widthToNumber = parseInt(fileSize.split(' x ')[0].split('p')[0].trim(), 10);
  const heightToNumber = parseInt(fileSize.split(' x ')[1].split('p')[0].trim(), 10);
  return heightToNumber / widthToNumber;
};

export const checkNonDecimalCurrency = (currencyCode: string) => {
  const nonDecimalCurrency = [
    'JPY',
    'KRW',
    'VND',
    'IDR',
    'BIF',
    'CLP',
    'DJF',
    'GNF',
    'KMF',
    'MGA',
    'PYG',
    'RWF',
    'UGX',
    'VUV',
    'XAF',
    'XOF',
    'XPF',
  ];
  return nonDecimalCurrency.includes(currencyCode);
};

export const convertCurrency = (amount: string, currencyCode: string) => {
  const isNonDecimalCurrency = checkNonDecimalCurrency(currencyCode);

  const value = currencyFormatter.format(Number(amount), {
    code: currencyCode,
    precision: isNonDecimalCurrency ? 0 : 2,
  });
  return value;
};
